import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

export const energyConsumerUnitSchema = yup.object().shape({
  code: yup.string().required(t('errors.required', { label: t('contract_optimizer.consumer_units.fields.code') })),
  name: yup.string().required(t('errors.required', { label: t('contract_optimizer.consumer_units.fields.name') })),
})
